
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","data-name":"vuesax/twotone/slash"}},[_c('path',{attrs:{"d":"M20 36.666A16.667 16.667 0 103.333 20 16.673 16.673 0 0020 36.666z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M31.5 8.333L8.167 31.666","opacity":".34"}})])])
          )
        }
      }
    